<template>
  <div class="width-100 pa-2 div-tab">
    <div class="tab">
      <button  v-for="tab in tabs" :key="tab.id" :class="tab.class" @click="openTab($event, tab.id)">
        <i :class="`fas ${tab.icon} tab-icon`"></i>{{tab.name}}
      </button>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    tabs: {
      required: true
    }
  },
  methods: {
    openTab (evt, cityName) {
      var i, tabcontent, tablinks
      tabcontent = document.getElementsByClassName('tabcontent')
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = 'none'
      }
      tablinks = document.getElementsByClassName('tablinks')
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(' active', '')
      }
      document.getElementById(cityName).style.display = 'block'
      evt.currentTarget.className += ' active'
    }
  }
}
</script>
<style scoped>
.div-tab {
  border-radius: 15px;
  background-color: #313131;
}
/* TAB COMEÇA AQUI */
.tab {
  overflow: hidden;
  display: flex;
  border-radius: 15px 15px 0px 0px;
}

/* Style the buttons inside the tab */
.tab button {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  margin: 0;
  padding: 14px 16px;
  transition: 0.3s;
}
.tab-icon {
  vertical-align: middle;
  margin-right: 10px;
}
.tablinks {
  font-size: 17px;
  font-weight: 900;
  color: white;
  border-radius: 15px 15px 0px 0px;
}

/* Change background color of buttons on hover */
.tab button:hover {
  background-color: white;
  color: #0079be;
}

/* Create an active/current tablink class */
.tab button.active {
  background-color: white;
  color: #0079be;
}

/* Style the tab content */
.tabcontent {
  display: none;
  background-color: white;
  padding: 6px 12px;
  -webkit-animation: fadeEffect 1s;
  animation: fadeEffect 1s;
  color: black;
  border-radius: 0px 0px 15px 15px;
}

/* Fade in tabs */
@-webkit-keyframes fadeEffect {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeEffect {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
